import { useState, useEffect } from "react"
import { Dropdown } from "react-bootstrap"
import LitigationClientHeader from "../../Components/Litigation/LitigationClientHeader"
import InputLabel from "@material-ui/core/InputLabel"
import Arrow from "../../../Static/RawImages/arrow.png"
import { Link } from "react-router-dom"
// NOTE: Assuming these imports are correct and available
import { clientListingAPI, generateSample, approveSample, sendSample } from "../../../API/litigationApis" 
import { showToast } from "../../../utils/handleToast"
import Pagination from "../../Components/pagination/Pagination"
import { Modal, Button, Form } from "react-bootstrap"
import SelectDropdown from "../../../ui/forms/SelectDropdown"

export default function LitigationClient() {
  // State for clients data
  const [clients, setClients] = useState([])
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalOpenClient, setIsModalOpenClient] = useState(false)
  const [isModalOpenForApprove, setIsModalOpenForApprove] = useState(false)
  const [selectedValue, setSelectedValue] = useState("")
  const [pendingClient, setPendingClient] = useState(null) // Store the client awaiting action

  // Category options for dropdowns
  const categoryOptions = [
    { label: "--Choose--", value: "" },
    { label: "Summary Suit", value: "summary_suit" },
    { label: "Commercial Suit", value: "comm_suit" },
    { label: "Pre Execution Petition", value: "pre_ep" },
    { label: "Mediation Application", value: "mediation_application" },
    { label: "Interim Application", value: "interim_application" },
    { label: "Original Application", value: "original_application" },
    { label: "Loan Recall Notice", value: "loan_recall_notice" },
    { label: "Sec 95", value: "sec_95" },
  ]

  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    page_number: 1,
  })

  // offcanvas & modal state
  const [showHistory, setShowHistory] = useState(false)
  const [showUpload, setShowUpload] = useState(false)

  // State for reload functionality
  const [hitReload, setHitReload] = useState(false)

  // State for search parameters (used by the header)
  const [searchParameter, setSearchParameter] = useState({})

  // State for selected clients
  const [selectedClients, setSelectedClients] = useState([])

  // State for download loading per client
  const [downloadingClients, setDownloadingClients] = useState({})

  // State for generate sample loading per client
  const [generatingSample, setGeneratingSample] = useState({})

  // State for approve sample loading per client
  const [approvingSample, setApprovingSample] = useState({})

  const [sendingSample, setsendingSample] = useState({})

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return null
    try {
      // Split the DD-MM-YYYY string
      const [day, month, year] = dateString.split("-")
      
      // Create a Date object in YYYY-MM-DD format (Month is 0-indexed in Date constructor)
      const dateObject = new Date(`${year}-${month}-${day}`)
      
      // Check if the date is valid
      if (isNaN(dateObject.getTime())) {
          return dateString // Return the original string if parsing fails
      }

      // Format the date
      return dateObject.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    } catch {
      return dateString // Return the original string on error
    }
  }

  // Helper function to check if client is new (created today)
  const isNewClient = (createdAt) => {
    if (!createdAt) return false
    
    try {
        const [day, month, year] = createdAt.split("-")
        const createdDate = new Date(`${year}-${month}-${day}`)
        const today = new Date()

        // Check if the client was created today
        return createdDate.toDateString() === today.toDateString()
    } catch (e) {
        // Fallback for parsing issues
        return false
    }
  }

  // Fetch clients from API
  const fetchClients = async (page = 1, searchParams = {}) => {
    try {
      setLoading(true)

      // Prepare API parameters
      const params = {
        page: page,
        ...searchParams,
      }

      // NOTE: Assuming a `clientListingAPI` exists.
      const response = await clientListingAPI(params)

      if (response?.status && response?.data) {
        
        const apiResults = Array.isArray(response.data) ? response.data : response.data.results || []
        const count = response.data.count || apiResults.length // Fallback for count

        // Transform API data to match expected client structure
        const transformedClients =
          apiResults.map((item) => ({
            id: item.id,
            // Use 'name' for the main client display name
            clientName: item.name || `CLIENT-${item.id}`,
            // Use 'client_created_at' and apply the modified formatDate helper
            date: formatDate(item.client_created_at) || "N/A",
            totalCases: item.total_cases || 0,
            // Use 'address' for location, as city/location isn't explicitly available
            location: item.address || "N/A",
            casesAssigned: item.total_cases || 0,
            // Use 'client_created_at' for 'isNew' check
            isNew: isNewClient(item.client_created_at),
            progress: {
              // The API data provided does *not* include these, so we default to 0
              notFiled: item.not_filed_percentage || 0,
              firstHearing: item.first_hearing_percentage || 0,
              inProgress: item.in_progress_percentage || 0,
              closed: item.closed_percentage || 0,
            },
            // Store original data for reference
            originalData: {
                ...item,
                // Add commonly used fields to originalData for easy access
                full_name: item.full_name,
                status: item.status || (item.send_to_client ? "Active" : "Pending Approval"), // Example Status logic
            },
          })) || []

        setClients(transformedClients)
        setPagination({
          count: count,
          next: response.data.next,
          previous: response.data.previous,
          page_number: response.data.page_number || page,
          total_pages: Math.ceil(count / 20), // Recalculate based on count
        })
      } else {
        // This handles cases where the API returns {status: true, data: []} or other failure states
        throw new Error(response?.message || "Failed to fetch clients")
      }
    } catch (error) {
      console.error("Error fetching clients:", error)
      showToast({
        variant: "error",
        message: error.message || "Failed to fetch clients",
      })
      setClients([])
      // Reset pagination on failure
      setPagination({ count: 0, next: null, previous: null, page_number: 1 })
    } finally {
      setLoading(false)
    }
  }

  const totalPages = Math.ceil(pagination.count / 20)

  // Check if any action is loading for a specific client
  const isAnyActionLoading = (clientId) => {
    return downloadingClients[clientId] || generatingSample[clientId] || approvingSample[clientId]
  }

  // Initial load effect
  useEffect(() => {
    setTimeout(() => {
      fetchClients(1, searchParameter)
    }, 500)
  }, [])

  // Reload effect
  useEffect(() => {
    if (hitReload) {
      setTimeout(() => {
        fetchClients(pagination.page_number, searchParameter)
        setHitReload(false)
      }, 500)
    }
  }, [hitReload])

  // Search parameter change effect
  useEffect(() => {
    if (Object.keys(searchParameter).length > 0) {
      setTimeout(() => {
        fetchClients(1, searchParameter)
      }, 500)
    }
  }, [searchParameter])

  // Toggle selection of a client
  const toggleClientSelection = (clientId) => {
    if (selectedClients.includes(clientId)) {
      setSelectedClients(selectedClients.filter((id) => id !== clientId))
    } else {
      setSelectedClients([...selectedClients, clientId])
    }
  }

  // Handle pagination
  const handlePageChange = (page) => {
    fetchClients(page, searchParameter)
  }

  return (
    <>
        <LitigationClientHeader setSearchParameter={setSearchParameter} setHitReload={setHitReload} />
      <hr className="mt-3 mb-5" />

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading clients...</p>
        </div>
      ) : clients.length === 0 ? (
        <div className="text-center py-5">
          <p className="text-muted">No clients found</p>
        </div>
      ) : (
        <>
          {/* Clients count and bulk actions */}
          <div className="row mb-3">
            <div className="col-md-6">
              <p className="text-muted">
                Showing {clients.length} of {pagination.count} clients
              </p>
            </div>
            <div className="col-md-6 text-end">
              {selectedClients.length > 0 && (
                <span className="text-info">{selectedClients.length} client(s) selected</span>
              )}
            </div>
          </div>

          {clients.map((client, index) => (
            <div key={client.id}>
              <div className="row d-flex justify-between batch-listing">
                {/* Left column - Client info */}
                <div className="col-md-3">
                  <div className="d-flex align-start">
                    <div className="form-check me-3 mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedClients.includes(client.id)}
                        onChange={() => toggleClientSelection(client.id)}
                      />
                    </div>
                    <div className="border-right-dotted w-100">
                      <p className="mb-2">
                        {/* FIX: This link path uses template literals and is correct. */}
                        <Link to={`/admin/litigation/cases?client=${client.id}`}>
                          <b className="text-blue" title={client.originalData?.full_name}>Client: {client.clientName}</b>
                        </Link>
                      </p>
                      {/* Displaying full name if available */}
                      {client.originalData?.full_name && client.originalData.full_name !== client.clientName && (
                        <p className="mb-2">
                          <span className="text-muted small">({client.originalData.full_name})</span>
                        </p>
                      )}
                      <p className="mb-2">
                        {/* Location is mapped to 'address' from the API data */}
                        <span className="batch-name" title={client.location}>
                          Location - {client.location || 'N/A'}
                        </span>
                      </p>
                      <p className="mb-2">Added On - {client.date}</p>
                      <p className="mb-2">Total Cases: {client.totalCases.toLocaleString()}</p>
                      {/* Additional info from API (if available in a real response) */}
                      {client.originalData?.contact_no && (
                        <p className="mb-2">Contact: {client.originalData.contact_no}</p>
                      )}
                      {client.originalData?.email_id && (
                        <p className="mb-2">Email: {client.originalData.email_id}</p>
                      )}
                      <div>
                        {client.isNew ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="43" height="25" viewBox="-263.6 383.2 43.3 25.2">
                            <path
                              className="st0"
                              fill="#FF5700"
                              d="M-220.3,395.8c0-7-5.7-12.6-12.6-12.6l-30.6,0l0,25.2l30.7,0C-226,408.4-220.3,402.8-220.3,395.8z M-232.9,406.6l-28.8,0l0-21.6l28.8,0c6,0,10.8,4.9,10.8,10.8C-222.1,401.8-227,406.6-232.9,406.6z"
                            />
                            <path
                              className="st0"
                              fill="#FF5700"
                              d="M-232.9,386.8l-27,0l0,18l27,0c5,0,9-4,9-9C-223.9,390.8-227.9,386.8-232.9,386.8z M-250.5,399.4l-1.6-2.8 c-0.4-0.8-0.9-1.7-1.3-2.6l0,0c0,1,0.1,2,0.1,3.2l0,2.2l-1.5,0l0-7.3l1.9,0l1.5,2.7c0.4,0.8,0.9,1.7,1.2,2.5l0,0 c-0.1-1-0.1-1.9-0.1-3l0-2.1l1.5,0l0,7.3L-250.5,399.4L-250.5,399.4z M-247.3,399.4l0-7.3l4.5,0l0,1.4l-2.8,0l0,1.5l2.7,0l0,1.3 l-2.7,0l0,1.7l3,0l0,1.3C-242.7,399.4-247.3,399.4-247.3,399.4z M-236.4,399.4l-0.6-3.1c-0.1-0.7-0.3-1.4-0.3-2.2l0,0 c-0.1,0.8-0.3,1.5-0.4,2.2l-0.7,3.1l-1.8,0l-1.7-7.3l1.8,0l0.6,3c0.2,0.9,0.3,1.8,0.4,2.5l0,0c-0.1-0.8,0.3-1.7,0.5-2.6l0.6-3 l1.8,0l0.6,3.1c0.2,0.9,0.3,1.6,0.4,2.4l0,0c0.1-0.8,0.3-1.7,0.4-2.5l0.6-3l1.7,0l-1.9,7.3 C-234.6,399.4-236.4,399.4-236.4,399.4z M-228.2,397.7c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2 C-226.2,396.9-227.1,397.8-228.2,397.7z"
                            />
                          </svg>
                        ) : (
                          <p>
                            {/* Use status from originalData. It's not in the mock, so default logic applied in fetchClients */}
                            Status -{" "}
                            <span className="text-success fw-bold">{client.originalData?.status || "Active"}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Middle column - Progress visualization */}
                <div className="col-md-6 border-right-dotted">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Circle progress indicator */}
                      <div className="ps-4">
                        <div className="position-relative" style={{ width: "120px", height: "120px", margin: "0 auto" }}>
                          {/* Circle background */}
                          <div
                            className="position-absolute top-0 start-0 rounded-circle"
                            style={{
                              width: "100%",
                              height: "100%",
                              border: "3px solid #f0f0f0",
                            }}
                          ></div>

                          {/* Progress circle - only show if there are cases assigned */}
                          {client.casesAssigned > 0 && (
                            <div
                              className="position-absolute top-0 start-0 rounded-circle"
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "3px solid #20B2AA",
                                borderRadius: "50%",
                                clipPath: "polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, 50% 0%)",
                                transform: "rotate(45deg)",
                              }}
                            ></div>
                          )}

                          {/* Small circle indicator */}
                          {client.casesAssigned > 0 && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "12px",
                                height: "12px",
                                backgroundColor: "#20B2AA",
                                borderRadius: "50%",
                                top: "0%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            ></div>
                          )}

                          {/* Text in center */}
                          <div className="position-absolute top-50 start-50 translate-middle text-center">
                            <div className="fw-bold">{client.casesAssigned.toLocaleString()}</div>
                            <div className="small text-muted">Cases Assigned</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* Progress bars */}
                      <div className="row status-progress">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">Not Filed ({client.progress.notFiled}%)</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div className="progress-bar bg-info" style={{ width: `${client.progress.notFiled}%` }}></div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">First Hearing ({client.progress.firstHearing}%)</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div className="progress-bar bg-info" style={{ width: `${client.progress.firstHearing}%` }}></div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">In-progress ({client.progress.inProgress}%)</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div className="progress-bar bg-info" style={{ width: `${client.progress.inProgress}%` }}></div>
                          </div>
                        </div>

                        <div>
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">Closed ({client.progress.closed}%)</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div className="progress-bar bg-info" style={{ width: `${client.progress.closed}%` }}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right column - Action dropdown */}
                <div className="col-md-3 ps-5">
                  <InputLabel id="label" className="mb-1">
                    Action
                  </InputLabel>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="w-100 text-start select-style"
                      disabled={isAnyActionLoading(client.id)}
                    >
                      {isAnyActionLoading(client.id) ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          Select <img src={Arrow} alt="Sort" />
                        </>
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="select-style-dropdown">
                      <Dropdown.Item>View Batches</Dropdown.Item>
                      <Dropdown.Item>View Cases</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <hr className="mt-4 mb-4" />
            </div>
          ))}

          {/* Pagination */}
          <div className="d-flex justify-content-end">
            <Pagination
              current={pagination.page_number}
              total={pagination.total_pages}
              onPageChange={handlePageChange}
              totalPages={totalPages}
            />
          </div>

          {/* Bulk Actions Bar */}
          {selectedClients.length > 0 && (
            <div className="fixed-bottom bg-light border-top p-3 shadow">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <span className="fw-bold">{selectedClients.length} client(s) selected</span>
                  </div>
                  <div className="col-md-6 text-end">
                    <button className="btn btn-sm btn-outline-primary me-2">Bulk Update</button>
                    <button className="btn btn-sm btn-outline-success me-2">Export Selected</button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedClients([])}>
                      Clear Selection
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}